<template>
  <div class="RuleObject boxs">
    <!-- 规则对象 -->
    <div class="grayTltleLine boxs" style="margin-top:25px">
      规则对象
    </div>

    <!-- 添加按钮 -->
    <div v-if="this.topTitle.subTit != '分销详情'" style="width:100%; margin-top:12px;">
      <button class="butStyle addBtn flex_h_hC_vC"
              @click="addMember"
      >
        <i class="icon"></i>
        <span>添加会员</span>
      </button>
    </div>

    <ul class="memberUl" v-if="this.topTitle.subTit != '分销详情'">
      <li v-for="(item, index) in memberList"
          :key="index"
      >
        <span>{{item.name}}</span>
        <i class="close" @click="removeMember(item, index)">x</i>
      </li>
    </ul>

    <ul class="memberUl" v-if="this.topTitle.subTit == '分销详情'">
      <li v-for="(item, index) in memberList"
          :key="index"
      >
        <span>{{item.name}}</span>
      </li>
    </ul>



    <!-- 弹窗 -->
    <el-dialog width="660px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible" @close="closeDialog" :before-close="beforeClose" :close-on-click-modal=false>
      <!-- 筛选框 -->
      <sr-filter class="searchBox" @search="handleSearch2" @reset="handleReset2">
        <template slot="otherCom">

          <el-form-item>
            <el-input
                    v-model="postForm.params.code"
                    placeholder="输入会员账号"
                    @keyup.enter.native="handleSearch2"
                    maxlength="25" size="medium" clearable
            >
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-input
                    v-model="postForm.params.name"
                    placeholder="输入会员名称"
                    @keyup.enter.native="handleSearch2"
                    maxlength="25" size="medium" clearable
            >
            </el-input>
          </el-form-item>

        </template>
      </sr-filter>


      <!-- max-height="200" -->
      <el-table :data="memberTableList"
                ref="memberTable"
                tooltip-effect="dark"
                style="width: 100%"
                class="tableTheadGray3"
                border
                @select-all="selectAllChange"
                @select="selectOneSel"
      >
        <!-- 这是列表前面的勾选框 -->
        <el-table-column type="selection"  width="35"></el-table-column>

        <el-table-column label="会员账号" prop="code" min-width="220" header-align="center"
                         align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="会员名称" prop="name" min-width="180" header-align="center"
                         align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="会员类型" prop="type.text" min-width="140" header-align="center"
                         align="center" show-overflow-tooltip></el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pageBox2">
        <el-pagination :pager-count="5" @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="postForm.current"
                       :page-sizes="[10, 20, 30]" :page-size="postForm.size" :total="total2" layout="total, sizes, prev, pager, next">
        </el-pagination>
      </div>

      <span slot="footer" class="dialog-footer flex-row jus-c">
        <button @click="beforeClose" class="butStyle cancelBtn">取 消</button>
        <button @click="validateForm" class="butStyle submitBtn">确 定</button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import SrFilter from '@/components/Common/Filter/Filter'
  import {
    commissionMemberList,//查询会员列表(过滤掉已配置过规则的会员)
    getConfigMember, //根据佣金配置id获取会员-详情(配置对象)
    addConfigMember, //添加分销配置对象(添加会员)
    delConfigMember, //删除分销配置对象(删除会员)
    existsWdConfig, //校验代理商是否有配置过网点佣金
  } from '@/api/DistributionList/distributionList.js';

  // 弹窗的数据
  const defaultPostForm = {

    current: 1, //当前页码
    size: 10, //每页条数
    // sortDesc: 'updateTime',
    params: {
      // 分销类型
      ruleId: null,
      code: null, //会员账号
      name: null, //会员名称
    },
  }

  export default {
    name: 'RuleObject',
    props: {
      // memberList: {// 会员列表(已配置)
      //   required: false
      // },
      externalInfo: {
        required: false
      }
    },
    data () {
      return {
        distributionInfo: {
          memberSize: 0,
          addMemberArrStr: "",// 添加的会员数组
          addMemberArr: [],// 添加的会员数组
          addMemberIds: [],// 添加的会员id数组
        },

        //标题
        topTitle: {
          subTit: '',
        },

        operate: '', //add、edit

        // 会员列表(已配置)
        memberList: [],

        // 弹窗标题
        dialogMap: {
          addMember: '添加会员',
        },
        dialogTitle: '',
        // 添加弹窗是否显示
        dialogFormVisible: false,
        postForm: Object.assign({}, defaultPostForm),

        // 会员列表(未配置)
        memberTableList: [],
        total2: 0,
        // 列表勾选
        sels: [],

      }
    },
    components: {
      SrFilter
    },
    watch: {
      externalInfo(val) {
        this.distributionInfo.memberIds = val.memberIds
        this.distributionInfo.addMemberIds = val.addMemberIds
        // this.distributionInfo.weight = gToKg(val.goods_base.weight) || ''
      },
    },
    created () {
      // 获取上级页面携带的参数
      this.initData();
    },
    methods: {
      // 获取上级页面携带的参数
      initData() {
        var optionalParams = this.$route.query;
        // console.log('optionalParams', optionalParams);

        this.data = optionalParams.data;

        this.topTitle.subTit = optionalParams.subTit;
        this.postForm.params.ruleId = optionalParams.data.ruleId;
        if(optionalParams.operate =='add'){
          this.operate = 'add'
        }
        if(optionalParams.operate =='edit'){
          this.operate = 'edit'
          // 当前会员类型：运营商(operator)或代理商
          this.memberType = optionalParams.memberType;
        }
        if(optionalParams.operate =='show'){
          this.operate = 'show'

        }

        if (optionalParams.operate == 'edit' || optionalParams.operate == 'show') {
          this.getMemberUlList();
        }

      },

      // 根据佣金配置id获取会员
      async getMemberUlList() {
        try {
          const result = await getConfigMember({"configId": this.data.id});
          this.memberList = result.data;
          
        } catch (e) {
          console.log(e)
        }
      },

      


      // 删除会员
      async removeMember(item, index) {
        // console.log('removeMember-item', item)
        if(this.operate == 'add') { //添加分销时

            // 把点击删除的会员从显示会员数组中删除
            this.memberList.splice(index, 1)
            
        } else if(this.operate == 'edit') { //编辑分销时

            // if(this.memberList.length == 1) {
            //   this.$message.warning('至少保留一个会员对象')
            //   return;
            // }

            // 如果当前是运营商，要先判断下级代理商是否有配置规则，没有才能删除会员（代理商）
            if(this.memberType == 'operator') {
              // 校验代理商是否有配置过网点佣金
              try {
                const result = await existsWdConfig({"configId": this.data.id, "memberId": item.id, "ruleId": this.postForm.params.ruleId,});
                let hasWdConfig = result.data;
                if(hasWdConfig == true) {
                  this.$message.warning('网点正在使用当前分销规则，暂时不能编辑。')
                  return false;
                }
              } catch (e) {
                console.log(e)
              }
            }


            const delParma = {
              ruleId: this.postForm.params.ruleId,
              configId: this.data.id,
              dcCommissionMemberList: [{ memberId: item.id }]
            }
            // console.log('delParma', delParma)
            try {
              const result = await delConfigMember(delParma);
              this.$message.success('会员删除成功')
              this.getMemberUlList();
            } catch (e) {
              console.log(e)
            }

        }
        
      },

      // 会员列表每页条数变了
      handleSizeChange2 (val) {
        this.postForm.size = val
        this.getMemberList()
      },
      // 会员列表当前页码变了
      handleCurrentChange2 (val) {
        this.postForm.current = val
        this.getMemberList()
      },
      // 会员列表列表过滤查询
      handleSearch2 () {
        this.postForm.current = 1
        this.getMemberList(this.postForm)
      },
      // 会员列表搜索重置（清空）
      handleReset2 () {
        // this.postForm = Object.assign({}, defaultPostForm)
        this.postForm.params.code = null
        this.postForm.params.name = null
        this.getMemberList()
      },
      // 查询会员列表-表格
      async getMemberList() {
        try {
          const result = await commissionMemberList(this.postForm);
          this.memberTableList = result.data.records;
          this.total2 = result.data.total;
          // console.log('this.memberTableList', this.memberTableList)


          // 当前查询的数据的id数组，初始化勾选数组
          let currentTableIdArr = []
          this.memberTableList.filter((rowData) => {
            currentTableIdArr.push(rowData.id)
          })

          // 如果当前有勾选的数据
          if(this.distributionInfo.addMemberArr.length > 0){
            // 当前需要勾选的数据的数组
            let checkedGouArrData = []

            this.distributionInfo.addMemberArr.forEach(item =>{
              // 不知道为什么用数组的完整项匹配不到坐标，只能用每项中的唯一值ID去匹配
              let tableIndex = currentTableIdArr.indexOf(item.id)
              // 加入之前手动勾选的数据（即让添加授权数组的每一项去比对符合“当前页的表格数组中存在”的条件的项，再添加这一项到回显数组）
              if(tableIndex != -1) {
                checkedGouArrData.push(item)
                // console.log('checkedGouArrData-push', checkedGouArrData)
              }
            })
            // 显示勾选表格行事件
            this.$nextTick(() => {
              this.toggleSelection(checkedGouArrData)
            })
          }
        } catch (e) {
          console.log(e)
        }
      },
      // 显示勾选表格行事件
      toggleSelection(rows) {
        if(rows) {
          // console.log('rows.length', rows.length)
        }
        if (rows) {
          rows.forEach(row => {
            // this.$refs.memberTable.toggleRowSelection(row);
            this.$refs.memberTable.toggleRowSelection(row, true);
          });
        } else {
          // this.$refs.memberTable.clearSelection();
        }
      },

      // 添加会员-打开弹窗
      addMember() {
        if(this.operate == 'add') { //添加分销时，每次打开添加会员弹窗，都把之前勾选的会员清空
          this.memberList = [];
        }
        if(this.operate == 'edit') {//编辑分销时
          // console.log('this.memberList', this.memberList)
          // 因为编辑分销时，确定添加会员需要这些原有的会员id，所以每次准备添加会员的时候顺便先获取id
          if(this.memberList){
            this.memberList.forEach(item=>{
              this.distributionInfo.addMemberArr.push(item);
              let currentId = {
                memberId: item.id
              }
              this.distributionInfo.addMemberIds.push(currentId);
            })
          }
        }
        this.dialogTitle = 'addMember'
        this.dialogFormVisible = true
        this.getMemberList()
      },
      // 弹窗关闭前
      beforeClose () {
        this.resetData()
      },
      // 关闭弹窗
      closeDialog () {
        this.resetData()
      },
      // 关闭弹窗
      closeDialog2 () {
        this.dialogFormVisible = false;
        this.postForm = Object.assign({}, defaultPostForm);
        this.postForm.params.code = null;
        this.postForm.params.name = null;
        this.postForm.current = 1;
        this.postForm.size = 10;
      },
      // 重置表单
      resetData () {
        this.dialogFormVisible = false
        this.postForm = Object.assign({}, defaultPostForm)
        this.postForm.params.code = null;
        this.postForm.params.name = null;
        this.postForm.current = 1;
        this.postForm.size = 10;
        this.distributionInfo.addMemberArr = []
        this.distributionInfo.addMemberIds = []
      },
      // 验证表单
      validateForm () {
        if (this.distributionInfo.addMemberIds.length > 0) {
          this.submitForm()
        } else {
          this.$message.warning('当前没有勾选的会员')
          this.dialogFormVisible = true
        }
      },
      // 添加会员接口（用于“添加分销”）
      addMemberEvent(id) {
        const addParma = {
          ruleId: this.postForm.params.ruleId,
          configId: id,
          // dcCommissionMemberList: this.distributionInfo.addMemberIds,
          dcCommissionMemberList: JSON.parse(this.distributionInfo.addMemberArrStr)
        }

        // 添加会员
        if (this.dialogTitle === 'addMember') {
          addConfigMember(addParma).then(res => {
            if (res.header && res.header.code !== 0) {
              this.$message.error(res.header.message);
              return
            }
            this.$message.success('添加成功')
          })
        }
      },
      // 提交表单
      submitForm () {

        const editParma = {
          ruleId: this.postForm.params.ruleId,
          configId: this.data.id,
          dcCommissionMemberList: this.distributionInfo.addMemberIds
        }
        // console.log('editParma', editParma)

        // 如果当前是“编辑分销”
        if(this.dialogTitle === 'addMember' && this.operate == 'edit'){
          addConfigMember(editParma).then(res => {
            if (res.header && res.header.code !== 0) {
              this.$message.error(res.header.message)
              return
            }
            this.closeDialog()
            this.getMemberUlList();
            this.$message.success('添加成功')
          })
        }
        // 如果当前是“添加分销”
        else if(this.operate == 'add'){
          this.distributionInfo.memberSize = this.distributionInfo.addMemberIds.length;
          this.distributionInfo.addMemberArrStr = JSON.stringify(this.distributionInfo.addMemberIds);
          this.closeDialog2()

          // 把勾选的数据加入外面的会员展示数组
          this.distributionInfo.addMemberArr.forEach(item => {
            let index = this.memberList.indexOf(item)
            if(index == -1) {
              this.memberList.push(item)
            }
          })
          
        }

      },

      // 列表勾选(当用户手动勾选数据行的 Checkbox 时触发的事件)
      // selection：当前所有选中的数组
      // row：当前勾选变化的一行
      selectOneSel (selection, row) {
        // console.log('selectOneSel-selection', selection)
        // console.log('selectOneSel-row', row)

        let fd = selection.indexOf(row)
        let fd1 = this.distributionInfo.addMemberArr.indexOf(row)
        if(fd != -1){ // 如果是添加勾选操作
          if(fd1 == -1) {
            // console.log('添加勾选-row', row)
            // 只有当添加会员数组里面没有该对象时才添加进去（避免重复）
            this.distributionInfo.addMemberArr.push(row);
            let currentId = {
              memberId: row.id
            }
            this.distributionInfo.addMemberIds.push(currentId);
          }
        } else if(fd == -1){ // 如果是取消勾选操作
          if(fd1 != -1) {
            // console.log('取消勾选-row', row)
            // 只有当添加会员数组里面有该对象时才删除（避免报错）
            this.distributionInfo.addMemberArr.splice(fd1, 1);
            let currentId = {
              memberId: row.id
            }
            this.distributionInfo.addMemberIds.splice(fd1, 1);
          }
        }
        // console.log('selectOneSeladdMemberIds', this.distributionInfo.addMemberIds)
      },

      // 列表勾选(当选择项发生变化时会触发该事件)
      selectAllChange (val) {
        let sels = val
        // console.log('selectAllChange-val', val)

        // 全选
        if(sels.length > 0) {

          // 获取当前选中的数组
          let currentSelArr = []
          sels.filter((rowData) => {
            currentSelArr.push(rowData)
          })
          // console.log('currentSelArr', currentSelArr)

          // 添加数组，把它们的id组成新的数组addMemberIds
          let addMemberIds = []
          this.distributionInfo.addMemberIds.filter((rowData) => {
            addMemberIds.push(rowData.memberId)
          })

          currentSelArr.forEach(item =>{
            // 加入之前手动勾选的数据（即让当前勾选的数组的每一项去比对符合“添加数组中不存在”的条件的项，再添加这一项到添加数组）
            // 判断当前勾选的数组id有没有在addMemberIds(添加数组)中，如果不存在，就添加进去（避免重复添加）
            let selIndex = addMemberIds.indexOf(item.id);
            if(selIndex == -1) {
              addMemberIds.push(item.id)
              this.distributionInfo.addMemberArr.push(item);
              let currentId = {
                memberId: item.id
              }
              this.distributionInfo.addMemberIds.push(currentId);
            }
          })

          // console.log('selectAllChange-this.distributionInfo.addMemberIds', this.distributionInfo.addMemberIds)

        }
        // 全不选
        else if (sels.length == 0) {
          // console.log('全不选',)

          // 当前查询表格的数据数组，把它们的id组成新的数组currentTableIdArr
          let currentTableIdArr = []
          this.memberTableList.filter((rowData) => {
            currentTableIdArr.push(rowData.id)
          })

          // 添加数组，把它们的id组成新的数组addMemberIds
          let addMemberIds = []
          this.distributionInfo.addMemberIds.filter((rowData) => {
            addMemberIds.push(rowData.memberId)
          })
          // console.log('currentTableIdArr', currentTableIdArr)
          // console.log('this.distributionInfo.addMemberIds', this.distributionInfo.addMemberIds)
          // console.log('addMemberIds', addMemberIds)

          currentTableIdArr.forEach(item =>{
            // console.log('forEach-item', item)
            // 删除之前手动勾选的数据（即让当前勾选的数组的每一项去比对符合“添加数组中存存在”的条件的项，再从添加数组中删除这一项）
            // 判断当前表格的数组id有没有在addMemberIds(添加数组)中，如果存在，就删除这一项（避免重复删除）
            let selIndex = addMemberIds.indexOf(item);
            // console.log('forEach-selIndex', selIndex)
            if(selIndex != -1) {
              addMemberIds.splice(selIndex, 1);
              this.distributionInfo.addMemberArr.splice(selIndex, 1);
              this.distributionInfo.addMemberIds.splice(selIndex, 1);
            }
          })
          // console.log('addMemberIds-splice', addMemberIds)
          // console.log('this.distributionInfo.addMemberIds-splice', this.distributionInfo.addMemberIds)
        }
      },

    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

  // 灰色标题
  .grayTltleLine {
    width: 100%;
    height: 32px;
    line-height: 32px;
    background:#EEEEEE;
    padding-left: 14px;
    font-size: 12px;
    font-weight: bold;
  }


  // 规则对象
  .addBtn {
    width: 96px;
    height: 36px;
    line-height: 36px;
    font-size: 13px;
    border-radius: 4px;
    color: #ffffff;
    background-color: #FA6241;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
    margin-left: 14px;
  }

  .addBtn .icon {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url('../../../assets/images/distributionList/iconAdd.png') no-repeat;
    background-size: 18px 18px;
    // margin-left: 4px;
  }

  .memberUl {
    margin-top: 14px;
    min-height: 36px;
    display: flex;
    flex-flow: row wrap;
  }

  .memberUl li {
    width: auto;
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #2B2727;
    // display: inline-block;
    margin: 0 0 12px 14px;
    position: relative;
  }

  .memberUl li span {
    // height: 16px;
    // line-height: 16px;
    height: 100%;
    line-height: 100%;
    border:1px solid #EEEEEE;
    border-radius: 3px;
    padding: 10px 18px 10px 12px;
  }

  .memberUl li i.close {
    width: 20px;
    height: 20px;
    line-height: 20px;
    background: #FA6241;
    -webkit-border-radius: 0 11px 11px 0;
    -moz-border-radius: 0 11px 11px 0;
    border-radius: 0 11px 11px 0;
    cursor: pointer;
    text-align: center;
    font-style: normal;
    color: #fff;
    margin-left: 0px;
    display: inline-block;
  }


  // 弹窗按钮-取消按钮
  .cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
  }

  // 弹窗按钮-橙色按钮
  .submitBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }


  // 分页条2
  .pageBox2 {
    // width: 498px;
    width: 100%;
    padding: 10px 0px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
  }
  .pageBox2 .el-pagination {
    padding-right: 0px;
  }


</style>
